module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/brindisi.f952efe3ab98589498baadd9720c6461.jpg";